export default {
  fontSizes: {
    font_size_h1: '72px',
    font_size_h2: '32px',
    font_size_h3: '40px',
    font_size_h4: '32px',
    font_size_sub1: '24px',
    font_size_sub2: '18px',
    font_size_button: '16px',
    font_size_body1: '16px',
    font_size_body2: '14px',
    font_size_caption: '12px',
    font_size_mobile_h1: '40px',
    font_size_mobile_h2: '32px',
  },
  fonts: {
    fieldwork: {
      light: 'fieldwork-light',
      regular: 'fieldwork-regular',
      medium: 'fieldwork-medium',
      bold: 'fieldwork-bold',
    },
    roboto: {
      light: 'roboto-light',
      regular: 'roboto-regular',
      medium: 'roboto-medium',
      bold: 'roboto-bold',
    },
  },
}
